var $document;

document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
  console.log('CPB is loaded');
  customJS.init();
});

var customJS = {
  init: function() {
    this.initGlobals();
    this.overlayInsert();
    this.overlayClose();
    /*this.alertInsert();*/
    this.panelToggle();
    this.summaryToggle();
    this.renderButton();
    this.summaryTitleText();
    this.addToCartBtnText();
    this.removeValueText();
    this.panelsTitle();
    this.randomStats();
    this.voucherPrice();
    this.addLabelsToOnesInDOM();
    this.reInit(this);
  },
  initGlobals: function() {
    $document = $(document);
  },
  overlayInsert: function() {
    $('.product-detail--customization').append('<div class="product-detail--customization-overlay"><div class="product-detail--customization-overlay-cnt"><img src="https://cdn.shopify.com/s/files/1/0536/6572/6639/files/fankarta-przed-i-po.png?v=1614947092" alt="Karta przed i po obróbce Twojego zdjęcia" /><a href="#" class="product-detail--customization-overlay-btn">OK</a></div></div>')
  },
  overlayClose: function() {
    $(".product-detail--customization-overlay-btn").on("click",function(){
      $(this).parent().parent().addClass('is_hidden');
    });
  },
  /*alertInsert: function() {
		$('.product-detail--customization-alert-container').append('<div class="product-detail--customization-alert"><strong><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" fill="#fde800" /></svg> Lorem ipsum</strong>Mauris quis justo tellus. Sed eu fermentum ante. Donec fringilla, nisi vel porta iaculis, nibh leo auctor dolor, quis feugiat justo orci iaculis sem. Duis in congue nulla. Ut in elit suscipit, pellentesque dolor eu, feugiat leo. Donec suscipit luctus orci, et gravida nisl cursus id. Fusce porta id dui et bibendum.</div>')
    },*/
  panelToggle: function() {
    $("#product-builder").on("click", ".cpb-panel-title" ,function(){
      $(this).closest('.cpb-panel-wrapper').toggleClass('is_open');
    });
  },
  summaryToggle: function() {
    $(".cpb-selection-summary-title").on("click",function(){
      $(this).parent().toggleClass('is_open');
    });
  },
  renderButton: function() {
    var button =$("<a></a>").attr("href","#").attr("id","fk-random-stats").addClass('cpb-actions-btn').html("Generuj wartości losowe");
    $(".stats-generator-container").append(button);
    $(".stats-generator-container .cpb-category-content").remove();
    $(".stats-generator-container .cpb-category-title").remove();
  },
  summaryTitleText: function() {
    $(".cpb-selection-summary-title").html("Podsumowanie");
  },
  addToCartBtnText: function() {
    $(".cpb-add-to-cart-button span").html("Dodaj do koszyka");
  },
  removeValueText: function() {
    $('.cpb-selection-summary-list-item-category-value:contains("Value - ")').each(function(){
      $(this).html($(this).html().split("Value - ").join(""));
    });
  },
  panelsTitle: function() {
    var product = CPB.getStore().getState().Product;
    var changes = product.userChanges;
    var panels = Object.keys(changes);
    panels.forEach(function(panelId) {
      var title = 'STATYSTYKI';
      product.panels.forEach(function(panel) {
        if(panel.id === panelId) title = panel.title;
      });
    });
  },
  _triggerEventOnInput: function(elem, enteredValue, eventName) {
    var input = elem;
    var lastValue = input.value;
    input.value = enteredValue;
    var event = new Event(eventName, { bubbles: true });
    var tracker = input._valueTracker;
    if (tracker) {
      tracker.setValue(lastValue);
    }
    input.dispatchEvent(event);
  },
  _getRndInteger: function(min, max) {
    return Math.floor(Math.random() * (max - min + 1) ) + min;
  },
  randomStats: function() {
    var randomStat = function(e) {
      e.preventDefault();
      var inputs = document.querySelectorAll('.fk-stats input');
      var timer = function timer(ms) {
        return new Promise(function (res) {
          return setTimeout(res, ms);
        });
      };

      async function load() {
        for(var i=0;i < inputs.length;i++) {
          var stat = customJS._getRndInteger(50,99);
          customJS._triggerEventOnInput(inputs[i], stat, 'change');
          await timer(501);
        }
      }
      load();
    }
    $document.on('click','#fk-random-stats',randomStat);
  },
  voucherPrice: function(){
    var previousPrice = null;
    setInterval(function(){
      var price = parseFloat($('.cpb-product-price').html().replace(',','.'));
      if(price !== previousPrice){
        var inputs = document.querySelectorAll('.fk-voucher-value input');
        var timer = function timer(ms) {
          return new Promise(function (res) {
            return setTimeout(res, ms);
          });
        };
        async function load() {
          for(var i=0;i < inputs.length;i++) {
            customJS._triggerEventOnInput(inputs[i], price, 'change');
            await timer(501);
          }
        }
        load();
        previousPrice = price;
      }
    }, 1000) 
  },
  addLabelsToOnesInDOM: function() {
    $('.cpb-custom-img-with-labels').each(function(idx,el) {
      const category = $(el);
      category.find('.cpb-option-type-img').each(function(idx,el) {
        const option = $(el);
        if(option.find('.cpb-custom-category-img-label').length) return;
        const img = option.find('img');
        img.after($(`<p class="cpb-custom-category-img-label">${img.attr('alt')}</p>`));
      });
    });
  },
  reInit: function(_this) {
  	document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function(event) {
      setTimeout(function(){
        _this.addLabelsToOnesInDOM();
      },50);
  	});
  	document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', function(event) {
      _this.addLabelsToOnesInDOM();
  	})
  }
}
